// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
// import { jsPDF } from "jspdf";
// import Logo from '../Logo/White/Full/1Asset 13@72x-8.png';
// import Footer2 from "../Footer/Footer2";
// import Header1 from "../Header/Header1";
// import { useAuth } from '../../AuthContext';
// import CircularProgress from '@mui/material/CircularProgress';


// const API_URL = process.env.REACT_APP_API_URL;

// function PaymentDetails({ onLogout }) {

//   useEffect(() => {
//     window.scrollTo(0, 0);  // Scroll to top when this page is loaded
//   }, []);

//   const { userId } = useAuth();

//   const [transactions, setTransactions] = useState([]);
//   const [billingDetails, setBillingDetails] = useState({});
//   const [sessionDetails, setSessionDetails] = useState([]);


//   const [loading, setLoading] = useState(true);
//   const [loadingSeconds, setLoadingSeconds] = useState(0);
//   const [error, setError] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);  // State to manage dialog visibility
//   const [selectedTransaction, setSelectedTransaction] = useState(null);  // Store selected transaction for viewing the invoice

//   const totalAmount = Number(selectedTransaction?.amount || 0);
// const baseAmount = +(totalAmount / 1.18).toFixed(2);
// const gstAmount = +(totalAmount - baseAmount).toFixed(2);

// const isIntraState = billingDetails?.pincode === '560030'; // or more robust state check
// const cgst = isIntraState ? +(gstAmount / 2).toFixed(2) : 0;
// const sgst = isIntraState ? +(gstAmount / 2).toFixed(2) : 0;
// const igst = !isIntraState ? gstAmount : 0;


// function calculateGST(amount, billingPin, companyPin = '560030') {
//   const base = +(amount / 1.18).toFixed(2);
//   const gst = +(amount - base).toFixed(2);
//   const isIntra = billingPin === companyPin;

//   return {
//     base,
//     gst,
//     cgst: isIntra ? +(gst / 2).toFixed(2) : 0,
//     sgst: isIntra ? +(gst / 2).toFixed(2) : 0,
//     igst: !isIntra ? gst : 0,
//     isIntra,
//   };
// }


  
//       useEffect(() => {
//           let timer;
        
//           if (loading) {
//             setLoadingSeconds(0); // reset timer
//             timer = setInterval(() => {
//               setLoadingSeconds(prev => prev + 1);
//             }, 1000);
//           } else {
//             clearInterval(timer);
//             setLoadingSeconds(0); // optional reset after done
//           }
        
//           return () => clearInterval(timer); // cleanup on unmount or loading = false
//         }, [loading]);



//   const handleViewInvoice = async (transaction) => {
//   setSelectedTransaction(transaction);
//   setOpenDialog(true);
//   setLoading(true); // Start loading

//   try {
//     const response = await axios.get(`${API_URL}/api/session-details/`, {
//       params: { order_id: transaction.post_id, type: transaction.type },
//     });
//     setSessionDetails(response.data);
//   } catch (err) {
//     console.error("Failed to fetch session details", err);
//     setSessionDetails(null);
//   } finally {
//     setLoading(false); // Stop loading
//   }
// };

// const handleCloseDialog = () => {
//   setOpenDialog(false);
//   setSessionDetails([]);
// };




//   useEffect(() => {
//   const fetchTransactionsAndBilling = async () => {
//     setLoading(true); // Start loading

//     try {
//       const response = await axios.post(`${API_URL}/api/transactions/`, {
//         user_id: userId,
//       });

//       // Extract both parts from the response
//       const { transactions, billing_details } = response.data;

//       setTransactions(transactions);
//       setBillingDetails(billing_details); // Ensure this state exists
//     } catch (err) {
//       setError("Hey, you have not done any transactions yet!");
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   if (userId) {
//     fetchTransactionsAndBilling();
//   }
// }, [userId]);


//   if (loading) {
//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100vw',
//         height: '100vh',
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//         zIndex: 2000,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backdropFilter: 'blur(3px)',
//       }}
//     >
//       <Box sx={{ textAlign: 'center' }}>
//         <CircularProgress
//           size={60}
//           thickness={6}
//           sx={{
//             color: 'transparent',
//             '& .MuiCircularProgress-circle': {
//               stroke: 'url(#better-gradient)',
//             },
//           }}
//         />

//         {/* Gradient definition */}
//         <svg width="0" height="0">
//           <defs>
//             <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
//               <stop offset="0%" stopColor="#f30b96ff" />
//               <stop offset="50%" stopColor="#221ce0ff" />
//               <stop offset="100%" stopColor="#0eacebff" />
//             </linearGradient>
//           </defs>
//         </svg>

//         <Typography
//           variant="h6"
//           sx={{
//             mt: 2,
//             color: '#fff',
//             textShadow: '0 1px 3px rgba(0,0,0,0.7)',
//           }}
//         >
//           Loading Transaction Details... ({loadingSeconds} sec)
//         </Typography>
//       </Box>
//     </Box>
//   );
// }

//   if (error) return <div>{error}</div>;



//   const handleDownloadInvoice = async (transaction, billingDetails) => {
//   const fetchSessionDetails = async (orderId, type) => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${API_URL}/api/session-details/`, {
//         params: { order_id: orderId, type: type },
//       });
//       return response.data;
//     } catch (err) {
//       console.error("Session details fetch failed", err);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const session = await fetchSessionDetails(transaction.post_id, transaction.type);
//   const doc = new jsPDF();
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   const date = new Date(transaction.created_at);
//   const formattedDate = date.toLocaleDateString();
//   const formattedTime = date.toLocaleTimeString();

//   const printDate = new Date();
//   const printDateStr = printDate.toLocaleDateString();
//   const printTimeStr = printDate.toLocaleTimeString();

//   // === WATERMARK ===
//   doc.saveGraphicsState();
//   doc.setTextColor(230, 230, 230);
//   doc.setFontSize(45);
//   doc.setFont("helvetica", "bold");
//   doc.text("Anthrasync", pageWidth / 2, pageHeight / 2, {
//     angle: 45,
//     align: "center",
//     opacity: 0.05,
//   });
//   doc.restoreGraphicsState();

//   // === LOGO + HEADER ===
//   const logoWidth = 60;
//   const logoHeight = logoWidth / 4.5;
//   const logoX = pageWidth - logoWidth - 14;
//   const logoY = 10;
//   doc.addImage(Logo, "PNG", logoX, logoY, logoWidth, logoHeight);

//   doc.setFontSize(22);
//   doc.setTextColor(30, 144, 255);
//   doc.setFont(undefined, "bold");
//   doc.text("INVOICE", 14, 20);

//   doc.setFontSize(12);
//   doc.setTextColor(0);
//   doc.setFont(undefined, "bold");
//   doc.text("Anthrasync Solutions Private Limited", 14, 30);
//   doc.setFont(undefined, "normal");
//   doc.text("No 26, Laskar Hosur Road, Adugodi, Bangalore South,", 14, 36);
//   doc.text("Bengaluru, India - 560030", 14, 42);
//   doc.text("Phone: +91 7338259131 | contact@anthrasync.com", 14, 48);
//   doc.setTextColor(60);
//   doc.text("GST No: 29ABBCA0435C1Z8", 14, 54);

//   doc.setDrawColor(180);
//   doc.line(14, 58, 196, 58);

//   // === INVOICE DETAILS ===
//   doc.setFontSize(11);
//   doc.setTextColor(60);
//   const labelX = 14;
//   const valueX = 50;
//   let y = 64;

//   const addField = (label, value) => {
//     doc.text(`${label}`, labelX, y);
//     doc.setTextColor(0);
//     doc.text(`${value}`, valueX, y);
//     y += 6;
//     doc.setTextColor(60);
//   };

//   addField("Invoice No:", transaction.invoice_number || "N/A");
//   addField("Invoice Date:", formattedDate);
//   addField("Invoice Time:", formattedTime);
//   addField("Transaction ID:", transaction.transaction_id);
//   addField("Order ID:", transaction.post_id);

//   y += 6;
//   doc.setDrawColor(200);
//   doc.line(14, y, 196, y);
//   y += 8;

//   // === BILLING DETAILS ===
//   // doc.setFillColor(230, 240, 255);
//   // doc.rect(14, y, pageWidth - 28, 10, "F");
//   doc.setFontSize(13);
//   doc.setTextColor(0);
//   doc.setFont(undefined, "bold");
//   doc.text("BILL TO:", 16, y + 7);
//   y += 14;

//   doc.setFontSize(11);
//   doc.setFont(undefined, "normal");

//   const { name, surname, address, city, state, country, pincode, contact } = billingDetails || {};

//   const addText = (text) => {
//     if (text) {
//       doc.text(text, 14, y);
//       y += 5;
//     }
//   };

//   addText(`${name || ""} ${surname || ""}`);
//   addText(address);
//   addText(`${city || ""}, ${state || ""} - ${pincode || ""}`);
//   addText(country);
//   addText(contact ? `Phone: ${contact}` : null);

//   y += 4;
//   doc.line(14, y, 196, y);
//   y += 8;

//   // === SESSION DETAILS ===
//   if (session) {
//     // doc.setFillColor(245, 245, 245);
//     // doc.rect(14, y, pageWidth - 28, 10, "F");
//     doc.setFontSize(13);
//     doc.setFont(undefined, "bold");
//     doc.text("SESSION DETAILS", 16, y + 7);
//     y += 14;

//     doc.setFontSize(11);
//     doc.setFont(undefined, "normal");
//     addText(`Title: ${session.description}`);
//     addText(`Date: ${session.session_date}`);
//     addText(`Time: ${session.session_time}`);
//     addText(`Host: ${session.host_name} ${session.host_surname}`);

//     y += 2;
//     doc.line(14, y, 196, y);
//     y += 8;
//   }

//   // === GST CALCULATION ===
//   const totalAmount = Number(transaction?.amount || 0);
//   const baseAmount = +(totalAmount / 1.18).toFixed(2);
//   const gstAmount = +(totalAmount - baseAmount).toFixed(2);
//   const isIntraState = pincode === "560030";
//   const cgst = isIntraState ? +(gstAmount / 2).toFixed(2) : 0;
//   const sgst = isIntraState ? +(gstAmount / 2).toFixed(2) : 0;
//   const igst = !isIntraState ? gstAmount : 0;

//   // === TRANSACTION SUMMARY ===
//   doc.setFontSize(13);
//   doc.setFont(undefined, "bold");
//   doc.setTextColor(30, 144, 255);
//   doc.text("TRANSACTION SUMMARY", 14, y);
//   y += 8;

//   doc.setFontSize(11);
//   doc.setTextColor(0);
//   doc.setFont(undefined, "bold");
//   doc.text("Description", 14, y);
//   doc.text("Type", 110, y);
//   doc.text("Amount", 170, y);
//   y += 6;

//   doc.setFont(undefined, "normal");
//   doc.text(transaction.payment_reason, 14, y);
//   doc.text(transaction.type || "-", 110, y);
//   doc.text(`${totalAmount.toFixed(2)} INR`, 170, y);
//   y += 10;

//   doc.setFont(undefined, "bold");
//   doc.text("Base Amount:", 14, y); doc.setFont(undefined, "normal");
//   doc.text(`${baseAmount.toFixed(2)} INR`, 170, y); y += 6;

//   if (isIntraState) {
//     doc.setFont(undefined, "bold");
//     doc.text("CGST (9%):", 14, y); doc.setFont(undefined, "normal");
//     doc.text(`${cgst.toFixed(2)} INR`, 170, y); y += 6;

//     doc.setFont(undefined, "bold");
//     doc.text("SGST (9%):", 14, y); doc.setFont(undefined, "normal");
//     doc.text(`${sgst.toFixed(2)} INR`, 170, y); y += 6;
//   } else {
//     doc.setFont(undefined, "bold");
//     doc.text("IGST (18%):", 14, y); doc.setFont(undefined, "normal");
//     doc.text(`${igst.toFixed(2)} INR`, 170, y); y += 6;
//   }

//   y += 4;
//   doc.setFont(undefined, "bold");
//   doc.text("Total Paid:", 14, y); doc.setFont(undefined, "normal");
//   doc.text(`${totalAmount.toFixed(2)} INR`, 170, y); y += 6;

//   doc.setFont(undefined, "bold");
//   doc.text("Status:", 14, y); doc.setFont(undefined, "normal");
//   doc.text(`${transaction.status}`, 170, y);

//   y += 16;

//   // === FOOTER ===
//   doc.setFontSize(10);
//   doc.setTextColor(100);
//   doc.text("Thank you for choosing Anthrasync!", 14, y); y += 5;
//   doc.text("This is an electronically generated invoice and does not require a signature.", 14, y); y += 5;
//   doc.setTextColor(70);
//   doc.text(`Printed on: ${printDateStr} at ${printTimeStr}`, 14, y);

//   // === SAVE PDF ===
//   doc.save(`invoice_${transaction.transaction_id}.pdf`);
// };


//   return (
//     <div>
//       <Header1 userId={userId} onLogout={onLogout} />


//       <Typography
//         variant="h3"
//         component="h1"
//         align="center"
//         fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
//         sx={{
//           backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
//           mt: 5,
//           letterSpacing: 10,
//           WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
//           color: 'transparent',  // Makes the text itself transparent to show the gradient
//           // fontWeight: 'bold',  // Optional: you can make the text bold
//         }}
//         gutterBottom
//       >
//         Transaction History
//       </Typography>
//       <Box
//         sx={{
//           padding: { xs: "1rem", sm: "2rem" },
//           backgroundColor: "#000000",
//           color: "white",
//           borderRadius: "12px",
//           boxShadow: "0 10px 20px rgba(0, 0, 0, 0.25)",
//           ml: { xs: 0, sm: 5, md: 7 },
//           mt: 2,
//           overflow: "hidden",
//           width: "100%",
//           maxWidth: { xs: "100%", sm: "90%", md: "80%", lg: "90%" },
//         }}
//       >
//         <TableContainer
//           component={Paper}
//           sx={{
//             backgroundColor: "#000000",
//             borderRadius: "10px",
//             boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
//             width: "100%",
//             maxWidth: "100%",
//             overflowX: "auto",
//             marginBottom: "2rem",
//           }}
//         >
//           <Table sx={{ tableLayout: "auto", width: "100%" }}>
//             <TableHead>
//               <TableRow>
//                 {["S No.", "Order ID", "Date", "Time", "Transaction ID", "Type", "Status", "Cost", "Remarks", "View", "Download"].map((header, index) => (
//                   <TableCell
//                     key={index}
//                     sx={{
//                       color: "white",
//                       backgroundColor: "#2222",
//                       fontWeight: "bold",
//                       fontSize: { xs: "0.8rem", sm: "1rem" },
//                       textTransform: "uppercase",
//                       borderBottom: "1.5px solid #5555",
//                       textAlign: "center",
//                       fontFamily: "'Helvetica', sans-serif",
//                       letterSpacing: 3,
//                       "&:hover": { color: "#1E90FF", borderColor: "#1E90FF" },
//                     }}
//                   >
//                     {header}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {transactions.map((transaction, index) => {
//                 const date = new Date(transaction.created_at);
//                 const formattedDate = date.toLocaleDateString();
//                 const formattedTime = date.toLocaleTimeString();

//                 return (
//                   <TableRow key={transaction.id}>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {index + 1}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.post_id}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {formattedDate}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {formattedTime}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.transaction_id}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.type}
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         color: transaction.status === "success" ? "#4caf50" : "#f44336", // green if successful, red otherwise
//                         fontWeight: "bold",
//                         textAlign: "center",
//                         borderBottom: "1.5px solid #5555",
//                         letterSpacing: 2,
//                       }}
//                     >
//                       {transaction.status}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.amount}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.payment_reason}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.status === "success" && (
//                         <Button variant="outlined" sx={{ color: "#1E90FF", marginRight: "1rem", letterSpacing: 2 }} onClick={() => handleViewInvoice(transaction)}>
//                           View Invoice
//                         </Button>
//                       )}
//                     </TableCell>
//                     <TableCell sx={{ color: "white", textAlign: "center", borderBottom: "1.5px solid #5555", letterSpacing: 2 }}>
//                       {transaction.status === "success" && (
//                         <Button
//                           variant="outlined"
//                           sx={{ color: "#1E90FF", letterSpacing: 2 }}
//                           onClick={() => handleDownloadInvoice(transaction, billingDetails)}
//                         >
//                           Download Invoice
//                         </Button>

//                       )}
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
//   <DialogTitle
//     style={{
//       backgroundColor: '#f7f9fc',
//       fontWeight: 700,
//       color: '#0f1a2c',
//       fontFamily: 'Verdana, sans-serif',
//       fontSize: 22,
//       padding: '20px 24px',
//       borderBottom: '1px solid #e1e6eb',
//     }}
//   >
//     Invoice
//   </DialogTitle>

//   <DialogContent
//     dividers
//     style={{
//       fontFamily: 'Verdana, sans-serif',
//       backgroundColor: '#ffffff',
//       padding: '32px',
//       color: '#1a1a1a',
//     }}
//   >
//     {selectedTransaction && (
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
//         <img
//   src={Logo}
//   alt="Company Logo"
//   style={{ width: 260, objectFit: 'contain', display: 'block', margin: '0 auto' }}
// />


//         {/* Company & Invoice Header */}
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          
//           <div style={{ flex: 1 }}>
//             <h2 style={{ color: '#1e90ff', fontSize: 26, margin: 0 }}>INVOICE</h2>
//             <div style={{ fontSize: 14, lineHeight: 1.7, marginTop: 12 }}>
//               <strong>Anthrasync Solutions Private Limited</strong><br />
//               No 26, Laskar Hosur Road, Adugodi, Bangalore South<br />
//               Bengaluru, India - 560030<br />
//               Phone: +91 7338259131<br />
//               Email: contact@anthrasync.com<br />
//               GST No: <strong>29ABBCA0435C1Z8</strong>
//             </div>
//           </div>
          
//         </div>

//         {/* Invoice Metadata */}
//         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', fontSize: 14 }}>
//           <div>
//             <div><strong>Invoice No:</strong> {selectedTransaction.invoice_number || 'N/A'}</div>
//             <div><strong>Transaction ID:</strong> {selectedTransaction.transaction_id}</div>
//             <div><strong>Order ID:</strong> {selectedTransaction.post_id}</div>
//           </div>
//           <div style={{ textAlign: 'right' }}>
//             <div><strong>Date:</strong> {new Date(selectedTransaction.created_at).toLocaleDateString()}</div>
//             <div><strong>Time:</strong> {new Date(selectedTransaction.created_at).toLocaleTimeString()}</div>
//           </div>
//         </div>

//         {/* Billing Section */}
//         <div>
//           <h3 style={{
//             fontSize: 16,
//             color: '#0f1a2c',
//             borderBottom: '1px solid #ddd',
//             paddingBottom: 6,
//             marginBottom: 12
//           }}>Bill To</h3>
//           <div style={{ fontSize: 14, lineHeight: 1.6 }}>
//             {(billingDetails.name || billingDetails.surname) && (
//               <div><strong>{billingDetails.name || ''} {billingDetails.surname || ''}</strong></div>
//             )}
//             {billingDetails.address && <div>{billingDetails.address}</div>}
//             {(billingDetails.city || billingDetails.state || billingDetails.pincode) && (
//               <div>{billingDetails.city || ''}, {billingDetails.state || ''} - {billingDetails.pincode || ''}</div>
//             )}
//             {billingDetails.country && <div>{billingDetails.country}</div>}
//             {billingDetails.contact && <div>Phone: {billingDetails.contact}</div>}
//           </div>
//         </div>

//         {/* Session Info */}
//         {sessionDetails && (
//           <div>
//             <h3 style={{
//               fontSize: 16,
//               color: '#0f1a2c',
//               borderBottom: '1px solid #ddd',
//               paddingBottom: 6,
//               marginBottom: 12
//             }}>Session Details</h3>
//             <div style={{ fontSize: 14, lineHeight: 1.6 }}>
//               <div><strong>Title:</strong> {sessionDetails.description}</div>
//               <div><strong>Date:</strong> {sessionDetails.session_date}</div>
//               <div><strong>Time:</strong> {sessionDetails.session_time}</div>
//               <div><strong>Host:</strong> {sessionDetails.host_name} {sessionDetails.host_surname}</div>
//             </div>
//           </div>
//         )}

//         {/* Transaction Table */}
//         <div>
//           <h3 style={{
//             fontSize: 16,
//             color: '#1E90FF',
//             marginBottom: 12
//           }}>Transaction Summary</h3>
//           <table style={{
//             width: '100%',
//             borderCollapse: 'collapse',
//             fontSize: 14
//           }}>
//             <thead>
//               <tr style={{ backgroundColor: '#f0f2f5' }}>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ccc' }}>Description</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ccc' }}>Type</th>
//                 <th style={{ textAlign: 'right', padding: '12px 8px', borderBottom: '1px solid #ccc' }}>Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td style={{ padding: '12px 8px' }}>{selectedTransaction.payment_reason}</td>
//                 <td style={{ padding: '12px 8px' }}>{selectedTransaction.type || '-'}</td>
//                 <td style={{ textAlign: 'right', padding: '12px 8px' }}>{selectedTransaction.amount} INR</td>
//               </tr>
//             </tbody>
//           </table>

//           <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20, fontSize: 14 }}>
//   <div style={{ minWidth: 300 }}>
//     <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//       <span>Base Amount:</span>
//       <span>{baseAmount.toFixed(2)} INR</span>
//     </div>

//     {isIntraState ? (
//       <>
//         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//           <span>CGST (9%):</span>
//           <span>{cgst.toFixed(2)} INR</span>
//         </div>
//         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//           <span>SGST (9%):</span>
//           <span>{sgst.toFixed(2)} INR</span>
//         </div>
//       </>
//     ) : (
//       <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
//         <span>IGST (18%):</span>
//         <span>{igst.toFixed(2)} INR</span>
//       </div>
//     )}

//     <div style={{
//       display: 'flex',
//       justifyContent: 'space-between',
//       borderTop: '1px solid #ccc',
//       paddingTop: 10,
//       fontWeight: 700
//     }}>
//       <span>Total Paid:</span>
//       <span>{totalAmount.toFixed(2)} INR</span>
//     </div>

//     <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, color: '#007b00' }}>
//       <span>Status:</span>
//       <span>{selectedTransaction.status}</span>
//     </div>
//   </div>
// </div>
//         </div>

//         {/* Footer */}
//         <div style={{
//           marginTop: 40,
//           fontSize: 12,
//           color: '#888',
//           textAlign: 'center',
//           borderTop: '1px solid #eee',
//           paddingTop: 16
//         }}>
//           <p style={{ margin: 0 }}>Thank you for choosing <strong>Anthrasync</strong>.</p>
//           <p style={{ margin: 0 }}>This invoice was generated electronically and does not require a physical signature.</p>
//         </div>
//       </div>
//     )}
//   </DialogContent>

//   <DialogActions style={{ backgroundColor: '#f7f9fc', padding: '16px 24px' }}>
//     <Button
//       onClick={handleCloseDialog}
//       color="primary"
//       variant="outlined"
//       style={{
//         fontFamily: 'Verdana, sans-serif',
//         textTransform: 'none',
//         fontWeight: 600
//       }}
//     >
//       Close
//     </Button>
//   </DialogActions>
// </Dialog>

//       </Box>
//       <Footer2 />

//     </div>
//   );
// }

// export default PaymentDetails;


import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Button, Dialog, DialogActions, DialogContent,
  DialogTitle, Typography, Chip
} from "@mui/material";
import { jsPDF } from "jspdf";
import Logo     from '../Logo/White/Full/1Asset 13@72x-8.png';
import Footer2  from "../Footer/Footer2";
import Header1  from "../Header/Header1";
import { useAuth } from '../../AuthContext';
import CircularProgress from '@mui/material/CircularProgress';

const API_URL = process.env.REACT_APP_API_URL;

// ─── Type label + colour mapping ─────────────────────────────────────────────
// MODIFIED: added session + ai-training labels
const TYPE_META = {
  session:     { label: "Session Booking", color: "#1E90FF",  bg: "rgba(30,144,255,0.1)"  },
  post:        { label: "Post",            color: "#a78bfa",  bg: "rgba(167,139,250,0.1)" },
  subscription:{ label: "Subscription",   color: "#f59e0b",  bg: "rgba(245,158,11,0.1)"  },
  "ai-training":{ label: "AI Training",   color: "#10b981",  bg: "rgba(16,185,129,0.1)"  },
};

const getTypeMeta = (type) =>
  TYPE_META[type?.toLowerCase()] || { label: type || "—", color: "#8b949e", bg: "rgba(139,148,158,0.1)" };

// ─── Status badge ─────────────────────────────────────────────────────────────
// MODIFIED: unified status badge component
function StatusBadge({ status }) {
  const success = status?.toLowerCase() === "success";
  return (
    <Box sx={{
      display: "inline-flex", alignItems: "center",
      px: 1.2, py: "3px",
      borderRadius: "20px",
      background: success ? "rgba(0,230,118,0.1)" : "rgba(239,68,68,0.1)",
      border: `1px solid ${success ? "rgba(0,230,118,0.3)" : "rgba(239,68,68,0.3)"}`,
    }}>
      <Box sx={{
        width: 6, height: 6, borderRadius: "50%",
        background: success ? "#00e676" : "#ef4444",
        mr: 0.7, flexShrink: 0,
      }} />
      <Typography sx={{
        fontSize: "0.72rem", fontWeight: 600,
        color: success ? "#00e676" : "#ef4444",
        lineHeight: 1,
      }}>
        {success ? "Success" : "Failed"}
      </Typography>
    </Box>
  );
}

// ─── Type badge ───────────────────────────────────────────────────────────────
function TypeBadge({ type }) {
  const meta = getTypeMeta(type);
  return (
    <Box sx={{
      display: "inline-flex",
      px: 1.2, py: "3px",
      borderRadius: "20px",
      background: meta.bg,
      border: `1px solid ${meta.color}40`,
    }}>
      <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: meta.color, lineHeight: 1 }}>
        {meta.label}
      </Typography>
    </Box>
  );
}

// ─── Shared cell sx ───────────────────────────────────────────────────────────
const cellSx = {
  color: "#c9d1d9",
  textAlign: "center",
  borderBottom: "1px solid rgba(255,255,255,0.06)",
  fontSize: "0.82rem",
  py: 1.5,
  letterSpacing: "0.02em",
};

const headSx = {
  color: "#8b949e",
  backgroundColor: "#0d1117",
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  borderBottom: "1px solid rgba(255,255,255,0.08)",
  textAlign: "center",
  letterSpacing: "0.08em",
  py: 2,
};

// ─── Main component ───────────────────────────────────────────────────────────
function PaymentDetails({ onLogout }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const { userId } = useAuth();

  const [transactions,    setTransactions]    = useState([]);
  const [billingDetails,  setBillingDetails]  = useState({});
  const [sessionDetails,  setSessionDetails]  = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [loadingSeconds,  setLoadingSeconds]  = useState(0);
  const [error,           setError]           = useState(null);
  const [openDialog,      setOpenDialog]      = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  // ── Pricing helpers (unchanged) ───────────────────────────────────────────
  const totalAmount = Number(selectedTransaction?.amount || 0);
  const baseAmount  = +(totalAmount / 1.18).toFixed(2);
  const gstAmount   = +(totalAmount - baseAmount).toFixed(2);
  const isIntraState = billingDetails?.pincode === '560030';
  const cgst = isIntraState ? +(gstAmount / 2).toFixed(2) : 0;
  const sgst = isIntraState ? +(gstAmount / 2).toFixed(2) : 0;
  const igst = !isIntraState ? gstAmount : 0;

  // ── Loading timer ──────────────────────────────────────────────────────────
  useEffect(() => {
    let timer;
    if (loading) {
      setLoadingSeconds(0);
      timer = setInterval(() => setLoadingSeconds(p => p + 1), 1000);
    } else {
      clearInterval(timer);
      setLoadingSeconds(0);
    }
    return () => clearInterval(timer);
  }, [loading]);

  // ── Fetch transactions ─────────────────────────────────────────────────────
  // MODIFIED: same endpoint, no filtering — backend returns all types including 'session'
  useEffect(() => {
    if (!userId) return;
    const fetch = async () => {
      setLoading(true);
      try {
        const res = await axios.post(`${API_URL}/api/transactions/`, { user_id: userId });
        const { transactions, billing_details } = res.data;
        setTransactions(transactions);
        setBillingDetails(billing_details);
      } catch {
        setError("No transactions found yet.");
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [userId]);

  // ── Invoice dialog ─────────────────────────────────────────────────────────
  const handleViewInvoice = async (transaction) => {
    setSelectedTransaction(transaction);
    setOpenDialog(true);
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/session-details/`, {
        params: { order_id: transaction.post_id, type: transaction.type },
      });
      setSessionDetails(res.data);
    } catch {
      setSessionDetails(null);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => { setOpenDialog(false); setSessionDetails([]); };

  // ── Download invoice (unchanged logic) ────────────────────────────────────
  const handleDownloadInvoice = async (transaction, billingDetails) => {
    const fetchSession = async (orderId, type) => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_URL}/api/session-details/`, {
          params: { order_id: orderId, type },
        });
        return res.data;
      } catch { return null; }
      finally { setLoading(false); }
    };

    const session = await fetchSession(transaction.post_id, transaction.type);
    const doc = new jsPDF();
    const pageWidth  = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const date = new Date(transaction.created_at);
    const printDate = new Date();

    doc.saveGraphicsState();
    doc.setTextColor(230, 230, 230);
    doc.setFontSize(45);
    doc.setFont("helvetica", "bold");
    doc.text("Anthrasync", pageWidth / 2, pageHeight / 2, { angle: 45, align: "center" });
    doc.restoreGraphicsState();

    const logoWidth = 60; const logoHeight = logoWidth / 4.5;
    doc.addImage(Logo, "PNG", pageWidth - logoWidth - 14, 10, logoWidth, logoHeight);
    doc.setFontSize(22); doc.setTextColor(30, 144, 255); doc.setFont(undefined, "bold");
    doc.text("INVOICE", 14, 20);
    doc.setFontSize(12); doc.setTextColor(0); doc.setFont(undefined, "bold");
    doc.text("Anthrasync Solutions Private Limited", 14, 30);
    doc.setFont(undefined, "normal");
    doc.text("No 26, Laskar Hosur Road, Adugodi, Bangalore South,", 14, 36);
    doc.text("Bengaluru, India - 560030", 14, 42);
    doc.text("Phone: +91 7338259131 | contact@anthrasync.com", 14, 48);
    doc.setTextColor(60); doc.text("GST No: 29ABBCA0435C1Z8", 14, 54);
    doc.setDrawColor(180); doc.line(14, 58, 196, 58);

    let y = 64;
    const addField = (label, value) => {
  const safeValue = value !== null && value !== undefined ? String(value) : "N/A";

  doc.setFontSize(11);
  doc.setTextColor(60);
  doc.text(String(label), 14, y);

  doc.setTextColor(0);
  doc.text(safeValue, 50, y);

  y += 6;
};
    addField("Invoice No:", transaction.invoice_number || "N/A");
    addField("Invoice Date:", date.toLocaleDateString());
    addField("Invoice Time:", date.toLocaleTimeString());
    addField("Transaction ID:", transaction.transaction_id);
    addField("Order ID:", transaction.post_id || "N/A");
    // MODIFIED: show type in invoice
    addField("Type:", getTypeMeta(transaction.type).label);

    y += 4; doc.line(14, y, 196, y); y += 8;
    doc.setFontSize(13); doc.setFont(undefined, "bold"); doc.setTextColor(0);
    doc.text("BILL TO:", 16, y + 7); y += 14;
    doc.setFontSize(11); doc.setFont(undefined, "normal");
    const { name, surname, address, city, state, country, pincode, contact } = billingDetails || {};
    const addText = (t) => { if (t) { doc.text(t, 14, y); y += 5; } };
    addText(`${name || ""} ${surname || ""}`);
    addText(address); addText(`${city || ""}, ${state || ""} - ${pincode || ""}`);
    addText(country); addText(contact ? `Phone: ${contact}` : null);

    y += 4; doc.line(14, y, 196, y); y += 8;

    if (session) {
      doc.setFontSize(13); doc.setFont(undefined, "bold");
      doc.text("SESSION DETAILS", 16, y + 7); y += 14;
      doc.setFontSize(11); doc.setFont(undefined, "normal");
      addText(`Title: ${session.description}`);
      addText(`Date: ${session.session_date}`);
      addText(`Time: ${session.session_time}`);
      addText(`Host: ${session.host_name} ${session.host_surname}`);
      y += 2; doc.line(14, y, 196, y); y += 8;
    }

    const tot = Number(transaction?.amount || 0);
    const base2 = +(tot / 1.18).toFixed(2);
    const gst2 = +(tot - base2).toFixed(2);
    const isIntra2 = pincode === "560030";
    const cgst2 = isIntra2 ? +(gst2 / 2).toFixed(2) : 0;
    const sgst2 = isIntra2 ? +(gst2 / 2).toFixed(2) : 0;
    const igst2 = !isIntra2 ? gst2 : 0;

    doc.setFontSize(13); doc.setFont(undefined, "bold"); doc.setTextColor(30, 144, 255);
    doc.text("TRANSACTION SUMMARY", 14, y); y += 8;
    doc.setFontSize(11); doc.setTextColor(0); doc.setFont(undefined, "bold");
    doc.text("Description", 14, y); doc.text("Type", 110, y); doc.text("Amount", 170, y); y += 6;
    doc.setFont(undefined, "normal");
    doc.text(transaction.payment_reason, 14, y);
    doc.text(getTypeMeta(transaction.type).label, 110, y);
    doc.text(`${tot.toFixed(2)} INR`, 170, y); y += 10;

    const addSummaryRow = (label, val) => {
      doc.setFont(undefined, "bold"); doc.text(label, 14, y);
      doc.setFont(undefined, "normal"); doc.text(val, 170, y); y += 6;
    };
    addSummaryRow("Base Amount:", `${base2.toFixed(2)} INR`);
    if (isIntra2) {
      addSummaryRow("CGST (9%):", `${cgst2.toFixed(2)} INR`);
      addSummaryRow("SGST (9%):", `${sgst2.toFixed(2)} INR`);
    } else {
      addSummaryRow("IGST (18%):", `${igst2.toFixed(2)} INR`);
    }
    y += 4;
    addSummaryRow("Total Paid:", `${tot.toFixed(2)} INR`);
    addSummaryRow("Status:", transaction.status);

    y += 16;
    doc.setFontSize(10); doc.setTextColor(100);
    doc.text("Thank you for choosing Anthrasync!", 14, y); y += 5;
    doc.text("This is an electronically generated invoice.", 14, y); y += 5;
    doc.text(`Printed on: ${printDate.toLocaleDateString()} at ${printDate.toLocaleTimeString()}`, 14, y);
    doc.save(`invoice_${transaction.transaction_id}.pdf`);
  };

  // ── Loading overlay ────────────────────────────────────────────────────────
  if (loading) {
    return (
      <Box sx={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        backdropFilter: 'blur(3px)',
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} thickness={6} sx={{
            color: 'transparent',
            '& .MuiCircularProgress-circle': { stroke: 'url(#better-gradient)' },
          }} />
          <svg width="0" height="0">
            <defs>
              <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                <stop offset="0%"   stopColor="#f30b96ff" />
                <stop offset="50%"  stopColor="#221ce0ff" />
                <stop offset="100%" stopColor="#0eacebff" />
              </linearGradient>
            </defs>
          </svg>
          <Typography variant="h6" sx={{ mt: 2, color: '#fff', textShadow: '0 1px 3px rgba(0,0,0,0.7)' }}>
            Loading... ({loadingSeconds}s)
          </Typography>
        </Box>
      </Box>
    );
  }

  if (error) return <Box sx={{ color: '#8b949e', textAlign: 'center', mt: 10 }}>{error}</Box>;

  // ── Table headers — MODIFIED: removed "View" for cleaner layout ───────────
  const HEADERS = ["#", "Date", "Time", "Transaction ID", "Type", "Status", "Amount", "Remarks", "Invoice"];

  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />

      <Typography
        variant="h3" component="h1" align="center"
        fontSize={{ xs: '1.8rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
          mt: 5, letterSpacing: 8,
          WebkitBackgroundClip: 'text', color: 'transparent',
        }}
        gutterBottom
      >
        Transaction History
      </Typography>

      <Box sx={{
        padding: { xs: "1rem", sm: "2rem" },
        backgroundColor: "#000000",
        borderRadius: "12px",
        ml: { xs: 0, sm: 5, md: 7 },
        mt: 2,
        width: "100%",
        maxWidth: { xs: "100%", sm: "90%", md: "80%", lg: "90%" },
      }}>
        <TableContainer component={Paper} sx={{
          backgroundColor: "#000000", borderRadius: "10px",
          overflowX: "auto", mb: "2rem",
        }}>
          <Table sx={{ tableLayout: "auto", width: "100%" }}>
            <TableHead>
              <TableRow>
                {HEADERS.map((h, i) => (
                  <TableCell key={i} sx={headSx}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {transactions.map((tx, index) => {
                const d = new Date(tx.created_at);
                return (
                  <TableRow
                    key={tx.id}
                    sx={{
                      '&:hover': { background: 'rgba(255,255,255,0.02)' },
                      transition: 'background 0.15s',
                    }}
                  >
                    <TableCell sx={cellSx}>{index + 1}</TableCell>

                    <TableCell sx={cellSx}>{d.toLocaleDateString()}</TableCell>
                    <TableCell sx={cellSx}>{d.toLocaleTimeString()}</TableCell>

                    <TableCell sx={{ ...cellSx, fontSize: '0.75rem', color: '#6e7a96', fontFamily: 'monospace' }}>
                      {tx.transaction_id || '—'}
                    </TableCell>

                    {/* MODIFIED: type badge */}
                    <TableCell sx={cellSx}>
                      <TypeBadge type={tx.type} />
                    </TableCell>

                    {/* MODIFIED: status badge */}
                    <TableCell sx={cellSx}>
                      <StatusBadge status={tx.status} />
                    </TableCell>

                    <TableCell sx={{ ...cellSx, color: '#00e676', fontWeight: 600 }}>
                      ₹{Number(tx.amount).toFixed(2)}
                    </TableCell>

                    <TableCell sx={{ ...cellSx, color: '#8b949e', fontSize: '0.78rem' }}>
                      {tx.payment_reason || '—'}
                    </TableCell>

                    {/* MODIFIED: combined View + Download in one cell */}
                    <TableCell sx={cellSx}>
                      {tx.status?.toLowerCase() === "success" && (
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                          <Button
                            size="small" variant="outlined"
                            onClick={() => handleViewInvoice(tx)}
                            sx={{
                              color: "#1E90FF", borderColor: "rgba(30,144,255,0.3)",
                              fontSize: "0.72rem", textTransform: "none", borderRadius: "8px",
                              '&:hover': { borderColor: "#1E90FF", background: "rgba(30,144,255,0.08)" },
                            }}
                          >
                            View
                          </Button>
                          <Button
                            size="small" variant="outlined"
                            onClick={() => handleDownloadInvoice(tx, billingDetails)}
                            sx={{
                              color: "#00e676", borderColor: "rgba(0,230,118,0.3)",
                              fontSize: "0.72rem", textTransform: "none", borderRadius: "8px",
                              '&:hover': { borderColor: "#00e676", background: "rgba(0,230,118,0.08)" },
                            }}
                          >
                            PDF
                          </Button>
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}

              {transactions.length === 0 && (
                <TableRow>
                  <TableCell colSpan={HEADERS.length} sx={{ ...cellSx, py: 6, color: '#484f58' }}>
                    No transactions yet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ── Invoice Dialog (unchanged structure, minor style cleanup) ── */}
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
          <DialogTitle sx={{
            backgroundColor: '#f7f9fc', fontWeight: 700, color: '#0f1a2c',
            fontFamily: 'Verdana, sans-serif', fontSize: 22,
            padding: '20px 24px', borderBottom: '1px solid #e1e6eb',
          }}>
            Invoice
          </DialogTitle>

          <DialogContent dividers sx={{
            fontFamily: 'Verdana, sans-serif', backgroundColor: '#ffffff',
            padding: '32px', color: '#1a1a1a',
          }}>
            {selectedTransaction && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                <img src={Logo} alt="Company Logo"
                  style={{ width: 260, objectFit: 'contain', display: 'block', margin: '0 auto' }} />

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <h2 style={{ color: '#1e90ff', fontSize: 26, margin: 0 }}>INVOICE</h2>
                    <div style={{ fontSize: 14, lineHeight: 1.7, marginTop: 12 }}>
                      <strong>Anthrasync Solutions Private Limited</strong><br />
                      No 26, Laskar Hosur Road, Adugodi, Bangalore South<br />
                      Bengaluru, India - 560030<br />
                      Phone: +91 7338259131 | Email: contact@anthrasync.com<br />
                      GST No: <strong>29ABBCA0435C1Z8</strong>
                    </div>
                  </div>
                  {/* MODIFIED: type badge in invoice header */}
                  <TypeBadge type={selectedTransaction.type} />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', fontSize: 14 }}>
                  <div>
                    <div><strong>Invoice No:</strong> {selectedTransaction.invoice_number || 'N/A'}</div>
                    <div><strong>Transaction ID:</strong> {selectedTransaction.transaction_id}</div>
                    <div><strong>Order ID:</strong> {selectedTransaction.post_id || 'N/A'}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div><strong>Date:</strong> {new Date(selectedTransaction.created_at).toLocaleDateString()}</div>
                    <div><strong>Time:</strong> {new Date(selectedTransaction.created_at).toLocaleTimeString()}</div>
                  </div>
                </div>

                <div>
                  <h3 style={{ fontSize: 16, color: '#0f1a2c', borderBottom: '1px solid #ddd', paddingBottom: 6, marginBottom: 12 }}>
                    Bill To
                  </h3>
                  <div style={{ fontSize: 14, lineHeight: 1.6 }}>
                    {(billingDetails.name || billingDetails.surname) && (
                      <div><strong>{billingDetails.name || ''} {billingDetails.surname || ''}</strong></div>
                    )}
                    {billingDetails.address && <div>{billingDetails.address}</div>}
                    {(billingDetails.city || billingDetails.state || billingDetails.pincode) && (
                      <div>{billingDetails.city}, {billingDetails.state} - {billingDetails.pincode}</div>
                    )}
                    {billingDetails.country && <div>{billingDetails.country}</div>}
                    {billingDetails.contact && <div>Phone: {billingDetails.contact}</div>}
                  </div>
                </div>

                {sessionDetails && (
                  <div>
                    <h3 style={{ fontSize: 16, color: '#0f1a2c', borderBottom: '1px solid #ddd', paddingBottom: 6, marginBottom: 12 }}>
                      Session Details
                    </h3>
                    <div style={{ fontSize: 14, lineHeight: 1.6 }}>
                      <div><strong>Title:</strong> {sessionDetails.description}</div>
                      <div><strong>Date:</strong> {sessionDetails.session_date}</div>
                      <div><strong>Time:</strong> {sessionDetails.session_time}</div>
                      <div><strong>Host:</strong> {sessionDetails.host_name} {sessionDetails.host_surname}</div>
                    </div>
                  </div>
                )}

                <div>
                  <h3 style={{ fontSize: 16, color: '#1E90FF', marginBottom: 12 }}>Transaction Summary</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f0f2f5' }}>
                        <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ccc' }}>Description</th>
                        <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ccc' }}>Type</th>
                        <th style={{ textAlign: 'right', padding: '12px 8px', borderBottom: '1px solid #ccc' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: '12px 8px' }}>{selectedTransaction.payment_reason}</td>
                        <td style={{ padding: '12px 8px' }}>{getTypeMeta(selectedTransaction.type).label}</td>
                        <td style={{ textAlign: 'right', padding: '12px 8px' }}>{selectedTransaction.amount} INR</td>
                      </tr>
                    </tbody>
                  </table>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20, fontSize: 14 }}>
                    <div style={{ minWidth: 300 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span>Base Amount:</span><span>{baseAmount.toFixed(2)} INR</span>
                      </div>
                      {isIntraState ? (
                        <>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                            <span>CGST (9%):</span><span>{cgst.toFixed(2)} INR</span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                            <span>SGST (9%):</span><span>{sgst.toFixed(2)} INR</span>
                          </div>
                        </>
                      ) : (
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                          <span>IGST (18%):</span><span>{igst.toFixed(2)} INR</span>
                        </div>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #ccc', paddingTop: 10, fontWeight: 700 }}>
                        <span>Total Paid:</span><span>{totalAmount.toFixed(2)} INR</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, color: '#007b00' }}>
                        <span>Status:</span><span>{selectedTransaction.status}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: 40, fontSize: 12, color: '#888', textAlign: 'center', borderTop: '1px solid #eee', paddingTop: 16 }}>
                  <p style={{ margin: 0 }}>Thank you for choosing <strong>Anthrasync</strong>.</p>
                  <p style={{ margin: 0 }}>This invoice was generated electronically and does not require a physical signature.</p>
                </div>
              </div>
            )}
          </DialogContent>

          <DialogActions style={{ backgroundColor: '#f7f9fc', padding: '16px 24px' }}>
            <Button onClick={handleCloseDialog} color="primary" variant="outlined"
              style={{ fontFamily: 'Verdana, sans-serif', textTransform: 'none', fontWeight: 600 }}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <Footer2 />
    </div>
  );
}

export default PaymentDetails;